/**
 * Presets with ILicensingEnvironment instances for using the I-Experts licensing service. You can choose between DEV, TEST or PROD (e.g. PRESETS.TEST)
 */
var LicensingEnvironments =
/** @class */
function () {
  function LicensingEnvironments() {}

  LicensingEnvironments.DEV = {
    hostname: "localhost:44381"
  };
  LicensingEnvironments.TEST = {
    hostname: "licensing-tst.iexpertsapps.nl"
  };
  LicensingEnvironments.PROD = {
    hostname: "licensing.iexpertsapps.nl"
  };
  return LicensingEnvironments;
}();

export { LicensingEnvironments };